import FoodList from "../components/food/foodList/FoodList";

const AllRecipes = () => {
  return (
    <div className="all-recipes-page">
      <FoodList />
    </div>
  );
};
export default AllRecipes;
